export {default} from "./Detalle"